export const lunchBreakDuration = [
  { label: 'None', value: 0 },
  { label: 'Insert 30 minute break', value: 30 },
  { label: 'Insert 45 minute break', value: 45 },
  { label: 'Insert 1 hour break', value: 60 },
  { label: 'Insert 90 minute break', value: 90 },
];
